module.exports = "../../../../platform/assets/pageMainIcon/simple_danjuweihulei7.svg";